import {
  Flex, HStack, Link, Text,
} from '@chakra-ui/react';
import {
  useRoadNetworkUseKPI,
} from '@src/modules/performance/context/reports-api-hooks';
import { roundKpiValue } from '@src/modules/performance/shared/helpers';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import ReportHeader from './ReportHeader';

const subheader = 'Roads and Bridges';
const informationSource = {
  title: 'Road Network Use',
  content: [
    {
      title: 'Million VKT / 10 Year Annual Avg Increase (%)',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      The annual average vehicle kilometres travelled on the selected road network for the last ten years. The annual average VKT growth for the latest ten years reported as a percentage of the start year total.
    </Text>
    <Text mb={2}>Road Efficiency Group Te Ringa Maimoa has calculated this result.</Text>
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools/" isExternal>NZTA Data and Tools, vehicle use</Link>
  </Text>,
    },
  ],
};

function RoadNetworkUseReportHeader({ ...rest }) {
  const { data: roadNetworkUseData, isLoadingKpi } = useRoadNetworkUseKPI();

  return (
    <ReportHeader
      title="Road Network Use"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      <Flex align="center">
        <HStack mr={3} spacing={0}>
          <CircleIndicator
            size={60}
            colour={roadNetworkUseData?.percentage !== undefined ? 'gray.700' : null}
            value={roadNetworkUseData?.percentage !== undefined ? `${roundKpiValue(roadNetworkUseData?.percentage, 5, 1, 'max')}%` : undefined}
            isLoading={isLoadingKpi || !roadNetworkUseData}
          />
          <Text>
            (
            {roundKpiValue(roadNetworkUseData?.value, 5, 1, 'max')}
            )
          </Text>
        </HStack>
        <Text fontWeight="bold" color="gray" fontSize="sm">
          Million VKT
          <br />
          <Text as="span" fontSize="xs" color="gray">
            (
            {roadNetworkUseData?.averageYearRange}
            {' '}
            Annual Avg)
          </Text>
        </Text>
      </Flex>
    </ReportHeader>
  );
}

export default RoadNetworkUseReportHeader;
